import Config from '../services/config'
export default function(shortName = 'none', env) {
  const { URL } = Config[env.toUpperCase()];
  const hasShortName = shortName && shortName !== 'none';
  let linkUrl = env === 'dev' ? `${URL}${hasShortName ? `?brand=${shortName}` : ''}` : hasShortName ? `https://${shortName}.crediblemind.com` : `https://crediblemind.com`;
  return linkUrl;
}